import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import WorkTableLine from "./WorkTableLine";
import homeImg from "../../Assets/home_img.png";

function Works() {
  // 사업 실적 데이터
  // const workData = [
  //   { year: "2025", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" },
  //   { year: "-", siteName: "사우스코리아", deliveryItems: "테라포밍 머신" }
  // ];

  const workData =[
  {year:"2025", siteName:"나래에너지", deliveryItems:	"파주발전소 HVAC유지보수"},
	{year:"2025", siteName:"나래에너지", deliveryItems:	"하남발전소 HVAC유지보수"},
	{year:"2025", siteName:"나래에너지", deliveryItems:	"위례발전소 HVAC유지보수"},
	{year:"2025", siteName:"나래에너지", deliveryItems:	"여주발전소 HVAC유지보수"},
	{year:"2025", siteName:"나래에너지", deliveryItems:	"이천발전소 HVAC유지보수"},
	{year:"2025", siteName:"나래에너지", deliveryItems:	"청주발전소 HVAC유지보수"},
	{year:"2025", siteName:"경기도자율주행센터", deliveryItems:	"항온항습기 6대 유지보수"},
	{year:"2025", siteName:"포천 파워텍", deliveryItems:	"SVH400 x 4대 설치공사"},
	{year:"2025", siteName:"나래에너지 / 청주", deliveryItems:	"청주발전소 냉각수 라인 세관 공사"},
	{year:"2025", siteName:"나래에너지 / 파주", deliveryItems:	"스크류 냉동기 콤프 오바홀"},
	{year:"2025", siteName:"나래에너지 / 하남", deliveryItems:	"판넬형 A/C 설치 공사"},
	{year:"2025", siteName:"나래에너지 / 파주", deliveryItems:	"항온항습기 설치 공사"},
	{year:"2025", siteName:"파주에너지 / 사무동", deliveryItems:	"HVAC유지보수"},
	{year:"2025", siteName:"파주에너지 / 강동연료전지", deliveryItems:	"HVAC유지보수"},
	{year:"2025", siteName:"나래에너지 / 하남", deliveryItems:	"기계실 밸브 교체 작업"},
	{year:"2025", siteName:"KDB산업은행  /하남", deliveryItems:	"공조기 보수 공사"},
	{year:"2025", siteName:"중곡동 정신의료원", deliveryItems:	"공조기 보수 공사"},


  {year:"2024", siteName:"용산 드래곤힐스", deliveryItems:	"냉각탑 보수 공사"},
  {year:"2024", siteName:"삼성엔지니어링 사옥", deliveryItems:	"공조기 보수 공사"},
  {year:"2024", siteName:"시흥 크린에너지", deliveryItems:	"항온항습기 외 납품 설치"},
  {year:"2024", siteName:"인천 SK아이지이(수소가스)", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"대산 CGN", deliveryItems:	"에어컨 설치 공사"},
  {year:"2024", siteName:"나래에너지 / 하남", deliveryItems:	"냉동기 보수"},
  {year:"2024", siteName:"나래에너지 / 감일가압장", deliveryItems:	"에어컨 보수"},
  {year:"2024", siteName:"리움미술관", deliveryItems:	"스크류냉동기 납품"},
  {year:"2024", siteName:"여의도 파크원", deliveryItems:	"냉각탑 보수"},
  {year:"2024", siteName:"나래에너지 파주발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"나래에너지 하남발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"나래에너지 위례발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"나래에너지 여주발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"나래에너지 이천발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"나래에너지 청주발전소", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"파주에너지 / 사무동", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"파주에너지 / 강동연료전지", deliveryItems:	"HVAC유지보수"},
  {year:"2024", siteName:"판교 자율주행센터", deliveryItems:	"항온항습기 유지보수"},
  {year:"2024", siteName:"건국대학교 과학관", deliveryItems:	"냉온수기 납품 설치"},
  {year:"2024", siteName:"서경대학교 압구정 CGV", deliveryItems:	"냉각탑 보수"},
  {year:"2024", siteName:"울산CEC / SK GAS", deliveryItems:	"HVAC유지보수"},


  {year:"2023", siteName:"안성 물류센터", deliveryItems:	"에어컨 납품 설치"},
  {year:"2023", siteName:"기업은행 / 수지 전산센터", deliveryItems:	"냉각탑 보수"},
  {year:"2023", siteName:"리움미술관 / 한남동", deliveryItems:	"항온항습기 설치"},
  {year:"2023", siteName:"우리은행 / 본점", deliveryItems:	"휀코일납품"},
  {year:"2023", siteName:"신한은행 / 본점", deliveryItems:	"휀코일납품"},
  {year:"2023", siteName:"인천 물류센터", deliveryItems:	"냉동기 외 납품 설치"},
  {year:"2023", siteName:"나래에너지 / 파주", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"나래에너지 / 하남", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"나래에너지 / 위례", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"나래에너지 / 이천", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"나래에너지 / 여주", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"파주에너지 / 사무동", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"파주에너지 / 강동연료전지", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"신한은행 본점", deliveryItems:	"냉각탑 보수"},
  {year:"2023", siteName:"건국대학교 창의관", deliveryItems:	"냉동기 냉각탑 납품 설치"},
  {year:"2023", siteName:"파주에너지 / 행정동", deliveryItems:	"HVAC유지보수"},
  {year:"2023", siteName:"파주에너지 / 강동연료전지", deliveryItems:	"HVAC유지보수"},
  ];


  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center" style={{ minHeight: "80vh" }}>
            <Col md={6} className="home-text-section">
              <div className="home-header">
                <h1 className="home-title">
                시공 사례
                </h1>
                <p className="home-description">
                동진에어택은 2006년 설립 이후 {new Date().getFullYear() - 2006}년 동안 <br className="tablet-line-break"/>
                300건이 넘는 다양한 시공을 진행해왔습니다.<br/>
                시공 완료 후에도 지속적인 유지보수 서비스를 통해 <br className="tablet-line-break"/>고객 만족과 신뢰를 구축해왔습니다.
                </p>
              </div>
            </Col>
            <Col md={6} className="home-image-section">
              <div className="home-image-container">
                <img 
                  src={homeImg} 
                  alt="동진에어텍 홈 이미지" 
                  className="home-main-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      
      {/* 사업 실적 표 섹션 */}
      <Container fluid className="works-table-section">
        <Container>
          <div className="works-table-container">
            <Table responsive className="works-table">
              <thead>
                <tr>
                  <th>년도</th>
                  <th>현장명</th>
                  <th>주요 납품 목록</th>
                </tr>
              </thead>
              <tbody>
                {workData.map((work, index) => (
                  <WorkTableLine
                    key={index}
                    year={work.year}
                    siteName={work.siteName}
                    deliveryItems={work.deliveryItems}
                  />
                ))}
              </tbody>
            </Table>
          </div>
        </Container>
      </Container>
    </section>
  );
}

export default Works;
